import React, { useMemo } from 'react';
import { RadialBarChart, RadialBar, ResponsiveContainer } from 'recharts';

interface SystemHealthChartProps {
  loading?: boolean;
}

const SystemHealthChart: React.FC<SystemHealthChartProps> = ({ loading }) => {
  if (loading) {
    return (
      <div className="h-64 flex items-center justify-center">
        <div className="animate-pulse bg-gray-200 dark:bg-gray-700 w-full h-full rounded-lg"></div>
      </div>
    );
  }

  const healthData = useMemo(() => [
    { name: 'Overall', value: 94, fill: '#10b981' },
    { name: 'Power', value: 98, fill: '#6366f1' },
    { name: 'Efficiency', value: 87, fill: '#f59e0b' },
    { name: 'Temperature', value: 92, fill: '#ef4444' }
  ], []);

  return (
    <div className="w-full h-64 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-4">
      <div className="h-44">
        <ResponsiveContainer width="100%" height="100%">
          <RadialBarChart data={healthData} innerRadius="25%" outerRadius="75%">
            <RadialBar 
              dataKey="value" 
              cornerRadius={8} 
              animationDuration={800}
            />
          </RadialBarChart>
        </ResponsiveContainer>
      </div>
      <div className="grid grid-cols-2 gap-2 mt-2">
        {healthData.map((item, index) => (
          <div key={index} className="flex items-center gap-2">
            <div 
              className="w-3 h-3 rounded-full border border-gray-300 dark:border-gray-600" 
              style={{ backgroundColor: item.fill }}
            ></div>
            <span className="text-xs text-gray-700 dark:text-gray-300 font-medium">
              {item.name}: {item.value}%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SystemHealthChart;